module.exports = __webpack_public_path__ + "static/media/Finacebanking.c61897e8.jpg";